module.exports = __webpack_public_path__ + "static/media/Medidas_1_4_5_6.fcc9aca2.pdf";